/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'refresh': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M18.39 7.454a.5.5 0 01.682.183 8.616 8.616 0 01-.284 9.072 8.614 8.614 0 01-8.252 3.78.5.5 0 01-.145-.044l2.735 2.735-.354.353-.354.354-3.83-3.83.353-.355 3.477-3.476.354.353.354.354-2.563 2.561a.5.5 0 01.098.003 7.616 7.616 0 008.562-7.315 7.615 7.615 0 00-1.016-4.045.5.5 0 01.182-.683zm-8.388 12.602l.142.142a.494.494 0 01-.043-.243l-.1.1zM14.637 3.83l-.353.355-3.477 3.476-.354-.353-.354-.354 2.553-2.553A7.613 7.613 0 005.02 15.75a.5.5 0 11-.865.5 8.613 8.613 0 018.652-12.835L10.1.707l.354-.353.354-.354 3.83 3.83z" _fill="#0077C8"/>'
  }
})
